// Purchase Actions

import Axios from 'axios'
import * as helpers from '@/mixins/helperFunctions.js'

// ***** Get purchaseList from backend then update purchaseList in vuex store ***** //
export const updatePurchaseList = async ({ commit }, payload = null) => {
  let params = {}

  if (payload) {
    params = {
      search: payload.search,
      page: payload.page,
      per_page: payload.rowsPerPage,
      column: payload.sortBy,
      sortDir: payload.descending ? 'desc' : 'asc'
    }
  }

  try {
    const result = await Axios.get('purchases_index', { params: params })
    commit('updatePurchaseList', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Get purchaseList from backend then update purchaseList in vuex store ***** //
export const updateReportPurchaseList = async ({ commit }, payload = null) => {
  let params = {}

  if (payload) {
    params = {
      search: payload.search,
      page: payload.page,
      per_page: payload.rowsPerPage,
      column: payload.sortBy,
      sortDir: payload.descending ? 'desc' : 'asc'
    }
  }

  try {
    const result = await Axios.get(`report_purchases/${payload.id}`, {
      params: params
    })
    commit('updatePurchaseList', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Fetch Purchase from backend ***** //
export const fetchPurchaseInfo = async ({ commit }, payload = null) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    const result = await Axios.get(`purchases_show/${payload}`)
    commit('fetchPurchaseInfo', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Fetch unClosedPurchaseCount from backend ***** //
export const fetchUnClosedPurchaseCount = async ({ commit }) => {
  try {
    const result = await Axios.get(`unclosed_purchase_count`)
    commit('fetchUnClosedPurchaseCount', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Fetch unClosedPurchaseCount from backend ***** //
export const fetchUnPaidPurchaseCount = async ({ commit }) => {
  try {
    const result = await Axios.get(`unpaid_purchase_count`)
    commit('fetchUnPaidPurchaseCount', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Fetch unClosedReportPurchaseCount from backend ***** //
export const fetchUnClosedReportPurchaseCount = async ({ commit }, payload) => {
  try {
    const result = await Axios.get(`report_unclosed_purchase_count/${payload}`)
    commit('fetchUnClosedPurchaseCount', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Fetch unPaidReportPurchaseCount from backend ***** //
export const fetchUnPaidReportPurchaseCount = async ({ commit }, payload) => {
  try {
    const result = await Axios.get(`report_unpaid_purchase_count/${payload}`)
    commit('fetchUnPaidPurchaseCount', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Close Purchase from backend ***** //
export const closePurchase = async (ignored, payload = null) => {
  if (!helpers.checkId(payload.id)) {
    throw new Error('Error')
  }

  try {
    await Axios.get(`purchases_close/${payload.id}`, { params: payload })
    helpers.ktNotify({
      type: 'success',
      text: 'Closed Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Open Purchase from backend ***** //
export const openPurchase = async (ignored, payload = null) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    await Axios.get(`purchases_unclose/${payload}`)
    helpers.ktNotify({
      type: 'success',
      text: 'Opened Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Add Purchase  ***** //
export const addPurchase = async (ignored, payload = null) => {
  try {
    await Axios.post('purchases_store', payload)
    helpers.ktNotify({
      type: 'success',
      text: 'Added Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, creation failed')
  }
}

// ***** Update Purchase  info ***** //
export const updatePurchaseInfo = async (ignored, payload = null) => {
  if (!helpers.checkId(payload.id)) {
    throw new Error('Error')
  }

  try {
    payload.formData.append('_method', 'PATCH')
    await Axios.post(`purchases_update/${payload.id}`, payload.formData)
    helpers.ktNotify({
      type: 'success',
      text: 'Updated Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, update failed')
  }
}

// ***** Delete Purchase  ***** //
export const deletePurchase = async (ignored, payload) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    await Axios.delete(`purchases_destroy/${payload}`)
    helpers.ktNotify({
      type: 'success',
      text: 'Deleted Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, deletion failed')
  }
}
